import React, { Suspense, Fragment, useState, useContext, useEffect } from "react";
import { Route, useNavigate } from "react-router-dom";
import Header from "../../components/header/index";
import Sidenav from "../../components/sidenav/index";
import WebSideNav from "../../components/sidenav/webSideNav";
import { BottomNavigation } from "../../components/bottomNavigation";
import Loading from "../../components/loading";
// import { Auth } from "../../offline-auth/auth";
import { PayLoadCtx, SignalerCtx } from "../../lib/context";
import { Auth } from "@aws-amplify/auth";
// import config from "../../config.json";
import { sessionSignOut } from "../../actions/users";

const AuthLayout = (props) => {
    const [sideNav, setSideNav] = useState(false);
    const navigate = useNavigate();
    // const { role, setRole } = useContext(RoleCtx);
    const { payload, setPayload } = useContext(PayLoadCtx);
    const { signaler } = useContext(SignalerCtx);

    const handleSideNav = () => {
        setSideNav((prevState) => !prevState);
    };

    async function revokeToken() {
        try {
            // SecureID access token (Cognito session no longer used).
            const token = localStorage.getItem("secureid_access_token");
            // let token = session.refreshToken.token;
            // await sessionSignOut(token).then(async () => {
            //     await Auth.signOut();
            // }).error((e)=>{
            //  console.log(`${e} logout`);
            // });
            localStorage.clear();
            sessionStorage.clear();
            // await currentuserinfo()
            navigate("/");

            // await Auth.signOut({ global: true });

            // const anotherReq = await sessionSignOut(accesstoken)
        } catch (error) {
            console.error("Error revoking token:", error);
        }
    }
    useEffect(() => {
        if (signaler) {
            signaler.on(`receivedDeleteUserMessage`, async (message) => {
                if (message === payload?.userId) {
                    // handleLogout();
                    setPayload(null);
                    // setRole(null);
                    // await Auth.signOut();
                    await revokeToken();
                    // localStorage.removeItem('currencyCode')
                }
            });
            return () => {
                signaler.off(`receivedDeleteUserMessage`, () => {});
            };
        }
    }, [signaler]);

    const handleLogout = async (e) => {
        // role && role !== "C" && e.preventDefault();
        // setLoading(true);
        // setRole(null);
        setPayload(null);
        // await Auth.signOut
        await revokeToken();
        // localStorage.removeItem('currencyCode')
        // history("/");
    };

    const isPatient = props.role === "P" || props.role === "patient" || props.role === "Patient";

    return (
        <Fragment>
            <Header handleSlide={handleSideNav} handleLogout={handleLogout} role={props.role} />
            {!isPatient && (
                <>
                    <Sidenav handleSlide={handleSideNav} slide={sideNav} handleLogout={handleLogout} role={props.role} />
                    <WebSideNav handleLogout={handleLogout} role={props.role} />
                </>
            )}
            <div className={isPatient ? "innerMainContainer noSideNav" : "innerMainContainer"}>
                <Suspense fallback={<Loading />}>{props.children}</Suspense>
            </div>
            <BottomNavigation handleLogout={handleLogout} />
        </Fragment>
    );
};

export default AuthLayout;
